import ShoppingCartIcon from '@mui/icons-material/ShoppingCart'

const CartWidget = () => {


    return(
        <div>
            <ShoppingCartIcon/>
        </div>
    )
}

export default CartWidget